export default __webpack_public_path__ + "static/media/panel_surya_rent.00769b34.jpg";